import type React from 'react'
import {useEffect} from 'react'
import {useLogout} from '@/hooks/useLogout'
import LoadingSpinner from '@/components/GDS/atoms/LoadingSpinner'

/**
 * Enhanced Logout component using the robust logout hook
 * Handles comprehensive cleanup and prevents race conditions
 */
const Logout: React.FC = () => {
  const {handleLogOut} = useLogout()

  useEffect(() => {
    handleLogOut()
  }, [handleLogOut])

  return <LoadingSpinner />
}

export default Logout
